import { useColorMode } from "~/providers/color-mode";
import { ThemeProvider } from "@mui/material";
import { artemisLight } from "~/themes/artemis-light";
import { artemisDark } from "~/themes/artemis-dark";
import WorkflowDetail from "~/pages/integrations/workflow/WorkflowDetail";

const WorkflowEntryPage = () => {
  const { mode } = useColorMode();

  return (
    <ThemeProvider theme={mode === "light" ? artemisLight : artemisDark}>
      <WorkflowDetail />
    </ThemeProvider>
  );
};

export default WorkflowEntryPage;
